const G = window.g

export const API_BASE_URL = G ? G.apiBaseUrl : 'http://127.0.0.1'
export const WEB_BASE_URL = G ? G.webRootUrl : 'http://127.0.0.1'
export const VIRTUAL_DIRECTORY = G ? G.virtualDirectory : '/'
export const Env = G.env

export const USER_INFO_STORAGE_KEY = 'ADMIN_USER_INFO'
export const USER_PERMISSION_KEY = 'USER_PERMISSION_KEY'
export const PAGE_SIZE_DEFAULT = 10

export const permissionKey = [
  'home',
  'customer',
  'businessType',
  'customerManagement',
  // 'customerMasterData',
  'apiManage',
  'apiManagement',
  'dataTarget',
  'dataSource',
  'azureAppRegistration',
  'azureKeyVault',
  'mappingManagement',
  'monitor',
  'messageManagement',
  'messageDetails',
  // 'indexManagement',
  'apiTools',
  // 'transportation',
  // 'massResend',
  'jobManagement',
  'groovyManagement',
  'permission',
  'permissionManagement',
  'userManagement',
  'roleManagement',
  'indexSearch',
  'formulaInfo',
  'formulaType',
  // 'rulesManagement',
  'emailManagement',
  'chat',
  'harness',

  'auditLogs',
  'reportManagement',
  'reportTag',
  'reportPage',
  'pbiReportPage',
  'dataFlowMonitoring',
  'dataFlowMonitoringConfig',
  'dataFlowLog',
  'marketingManagement',
  'marketingGroupManagement',
  'sms',
  'smsSignature',
  'smsTemplate',
  'addressBook',
  'shortLink',
  'smsManagement',
  'smsManagementDetails',
  'resourcePool',
  'emailSend',
  'emailAddress',
  'emailTemplate',
  'emailSendOnline',
  'emailList',
  'miceCad',
  'miceCadOea',
  'miceCadOeaSchedule',
  'fatigueConfig',
  'manualCall',
  'remarkTemplateList',
  'manualCallManagement',
  'intelligentCall',
  'intelligentCallModel',
  'intelligentCallManagement',
  'intelligentCallDetails',
  'themeSetting',
  'driveManagement',
  'driveList',
  'drivePermission',
  'driveSearch',
  'intelligentQuery',
  'terminologyConfig',
  'sqlExample',
  'queryAudit'
]

export const permissionOrder = [
  'home',
  'customerManagement',
  'customerMasterData',
  'businessType',
  'apiManagement',
  'dataTarget',
  'dataSource',
  'mappingManagement',
  'messageManagement',
  'messageDetails',
  'indexManagement',
  'transportation',
  'massResend',
  'jobManagement',
  'groovyManagement',
  'formulaInfo',
  'formulaType',
  'rulesManagement',
  'emailManagement',
  'chat',
  'harness',

  'permission',
  'permissionManagement',
  'userManagement',
  'roleManagement',
  'auditLogs',
  'reportManagement',
  'reportTag',
  'reportPage',
  'pbiReportPage',
  'dataFlowMonitoring',
  'dataFlowMonitoringConfig',
  'dataFlowLog',
  'marketingManagement',
  'marketingGroupManagement',
  'resourcePool',
  'shortLink',
  'sms',
  'smsSignature',
  'smsTemplate',
  'smsManagement',
  'smsManagementDetails',
  'emailSend',
  'emailAddress',
  'emailTemplate',
  'emailSendOnline',
  'emailList',
  'miceCad',
  'miceCadOea',
  'miceCadOeaSchedule',
  'fatigueConfig',
  'manualCall',
  'remarkTemplateList',
  'manualCallManagement',
  'intelligentCall',
  'intelligentCallModel',
  'intelligentCallManagement',
  'intelligentCallDetails',
  'themeSetting',
  'driveManagement',
  'driveList',
  'drivePermission',
  'driveSearch',
  'intelligentQuery',
  'terminologyConfig',
  'sqlExample',
  'queryAudit'
]
